import { createContext, ReactNode } from 'react';

export type MessageAction = { label: string; onClick: () => void };

/** Icon shown in a success toast, so people can see at a glance what was done. */
export type SuccessIcon =
  'complete' | 'pending' | 'sync' | 'email' | 'undo' | 'save' | 'person' | 'personAdd' | 'personRemove' | 'settings' | 'firm' | 'lockOpen' | 'lock';

export type MessageType = {
  content?: ReactNode | string;
  type?: 'error' | 'success' | 'progress';
  /** Optional button shown with a success message, e.g. Undo. */
  action?: MessageAction;
  icon?: SuccessIcon;
};

export type MessageContextType = {
  message?: MessageType;
  setMessage: Function;
};

export function error(message: ReactNode | string): MessageType {
  return { type: 'error', content: message };
}

export function success(message: ReactNode | string, options: { icon?: SuccessIcon; action?: MessageAction } = {}): MessageType {
  return { type: 'success', content: message, ...options };
}

export function progress(message: ReactNode | string): MessageType {
  return { type: 'progress', content: message };
}

export function empty(): MessageType {
  return {};
}

const MessageContext = createContext<MessageContextType>({
  setMessage: () => {},
});

export default MessageContext;
